import { reportingApi } from "@/api/reporting/reporting.api.ts";
import { ApiErrorException } from "@/types/api.types.ts";
import { ApiReportingDetailsInput } from "@/types/reporting/reporting.types.ts";
import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useQuery } from "@tanstack/react-query";

const reportingKeys = createQueryKeys("reporting", {
  details: (input: ApiReportingDetailsInput) => ({
    queryKey: [input],
    queryFn: async ({ signal }) => {
      const result = await reportingApi.details(input, signal);
      if (result.error) throw new ApiErrorException(result.error);
      return result.data;
    },
  }),
});

export const useReportingDetails = (input: ApiReportingDetailsInput, enabled: boolean = true) => {
  return useQuery({
    ...reportingKeys.details(input),
    enabled,
  });
};
